import fetch from "@/utils/request";
import i18n from "@/locales";
import { getApiHost } from "@/utils/apiHost";

export default {
  getStatementPdfPreviewUrl(pdf_url: string): string {
    const url = `${getApiHost()}/settlement/api/statement/pdf?pdf_url=${pdf_url}`;
    return encodeURIComponent(url);
  },

  getStatementDetail(data?: object): any {
    return fetch({
      url: "/settlement/api/statement/details",
      method: "get",
      data
    });
  },

  previewStatementPdf(data?: object): any {
    return fetch({
      url: "/settlement/api/statement/pdf",
      method: "get",
      responseType: "arraybuffer",
      data
    });
  },

  previewCommonPdf(data?: object): any {
    return fetch({
      url: "/settlement/api/statement/pdf",
      method: "get",
      responseType: "arraybuffer",
      data,
      loadingText: i18n.t("notice.loadingText")
    });
  }
};
